/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as googleType001 from '../../../../external/mercury/v1/shared/google/type/decimal.pb';
import * as booking_platformV1Shared002 from '../../../../external/mercury/v1/shared/geolocation.pb';
import * as booking_platformV1Shared003 from '../../../../external/mercury/v1/shared/auto-complete-result-item.pb';
import * as booking_platformV1Shared004 from '../../../../external/mercury/v1/shared/benefit-item.pb';
import * as googleProtobuf005 from '@ngx-grpc/well-known-types';
export enum SortBy {
  DEFAULT = 0,
  RATING = 1,
  DISTANCE = 2
}
export enum AutocompleteCategory {
  DINING_LOCATION = 0,
  DINING_VENUE = 1,
  DINING_ATTRIBUTE = 2
}
export enum AvailabilityStatus {
  AVAILABLE = 0,
  UNAVAILABLE = 1,
  ON_REQUEST = 2,
  UNDEFINED = 3
}
export enum PaymentRule {
  NoPayment = 0,
  AdvancedPayment = 1,
  SaveForLater = 2
}
/**
 * Message implementation for booking_platform.v1.dining.SearchRequest
 */
export class SearchRequest implements GrpcMessage {
  static id = 'booking_platform.v1.dining.SearchRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchRequest();
    SearchRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.locationId = _instance.locationId || undefined;
    _instance.geolocation = _instance.geolocation || undefined;
    _instance.venueIds = _instance.venueIds || [];
    _instance.pageSize = _instance.pageSize || 0;
    _instance.availableOnly = _instance.availableOnly || false;
    _instance.requestedAvailability =
      _instance.requestedAvailability || undefined;
    _instance.attributeIds = _instance.attributeIds || [];
    _instance.maxDistance = _instance.maxDistance || undefined;
    _instance.sortBy = _instance.sortBy || 0;
    _instance.hasBenefits = _instance.hasBenefits || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          _instance.locationId = new googleProtobuf000.Int32Value();
          _reader.readMessage(
            _instance.locationId,
            googleProtobuf000.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.geolocation = new booking_platformV1Shared002.Geolocation();
          _reader.readMessage(
            _instance.geolocation,
            booking_platformV1Shared002.Geolocation.deserializeBinaryFromReader
          );
          break;
        case 7:
          (_instance.venueIds = _instance.venueIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        case 8:
          _instance.pageSize = _reader.readInt32();
          break;
        case 9:
          _instance.availableOnly = _reader.readBool();
          break;
        case 10:
          _instance.requestedAvailability = new RequestedAvailability();
          _reader.readMessage(
            _instance.requestedAvailability,
            RequestedAvailability.deserializeBinaryFromReader
          );
          break;
        case 11:
          (_instance.attributeIds = _instance.attributeIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        case 12:
          _instance.maxDistance = new googleType001.Decimal();
          _reader.readMessage(
            _instance.maxDistance,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 13:
          _instance.sortBy = _reader.readEnum();
          break;
        case 14:
          _instance.hasBenefits = new googleProtobuf000.BoolValue();
          _reader.readMessage(
            _instance.hasBenefits,
            googleProtobuf000.BoolValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SearchRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.locationId) {
      _writer.writeMessage(
        5,
        _instance.locationId as any,
        googleProtobuf000.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.geolocation) {
      _writer.writeMessage(
        6,
        _instance.geolocation as any,
        booking_platformV1Shared002.Geolocation.serializeBinaryToWriter
      );
    }
    if (_instance.venueIds && _instance.venueIds.length) {
      _writer.writePackedInt32(7, _instance.venueIds);
    }
    if (_instance.pageSize) {
      _writer.writeInt32(8, _instance.pageSize);
    }
    if (_instance.availableOnly) {
      _writer.writeBool(9, _instance.availableOnly);
    }
    if (_instance.requestedAvailability) {
      _writer.writeMessage(
        10,
        _instance.requestedAvailability as any,
        RequestedAvailability.serializeBinaryToWriter
      );
    }
    if (_instance.attributeIds && _instance.attributeIds.length) {
      _writer.writePackedInt32(11, _instance.attributeIds);
    }
    if (_instance.maxDistance) {
      _writer.writeMessage(
        12,
        _instance.maxDistance as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.sortBy) {
      _writer.writeEnum(13, _instance.sortBy);
    }
    if (_instance.hasBenefits) {
      _writer.writeMessage(
        14,
        _instance.hasBenefits as any,
        googleProtobuf000.BoolValue.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _locationId?: googleProtobuf000.Int32Value;
  private _geolocation?: booking_platformV1Shared002.Geolocation;
  private _venueIds: number[];
  private _pageSize: number;
  private _availableOnly: boolean;
  private _requestedAvailability?: RequestedAvailability;
  private _attributeIds: number[];
  private _maxDistance?: googleType001.Decimal;
  private _sortBy: SortBy;
  private _hasBenefits?: googleProtobuf000.BoolValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.locationId = _value.locationId
      ? new googleProtobuf000.Int32Value(_value.locationId)
      : undefined;
    this.geolocation = _value.geolocation
      ? new booking_platformV1Shared002.Geolocation(_value.geolocation)
      : undefined;
    this.venueIds = (_value.venueIds || []).slice();
    this.pageSize = _value.pageSize;
    this.availableOnly = _value.availableOnly;
    this.requestedAvailability = _value.requestedAvailability
      ? new RequestedAvailability(_value.requestedAvailability)
      : undefined;
    this.attributeIds = (_value.attributeIds || []).slice();
    this.maxDistance = _value.maxDistance
      ? new googleType001.Decimal(_value.maxDistance)
      : undefined;
    this.sortBy = _value.sortBy;
    this.hasBenefits = _value.hasBenefits
      ? new googleProtobuf000.BoolValue(_value.hasBenefits)
      : undefined;
    SearchRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get locationId(): googleProtobuf000.Int32Value | undefined {
    return this._locationId;
  }
  set locationId(value: googleProtobuf000.Int32Value | undefined) {
    this._locationId = value;
  }
  get geolocation(): booking_platformV1Shared002.Geolocation | undefined {
    return this._geolocation;
  }
  set geolocation(value: booking_platformV1Shared002.Geolocation | undefined) {
    this._geolocation = value;
  }
  get venueIds(): number[] {
    return this._venueIds;
  }
  set venueIds(value: number[]) {
    this._venueIds = value;
  }
  get pageSize(): number {
    return this._pageSize;
  }
  set pageSize(value: number) {
    this._pageSize = value;
  }
  get availableOnly(): boolean {
    return this._availableOnly;
  }
  set availableOnly(value: boolean) {
    this._availableOnly = value;
  }
  get requestedAvailability(): RequestedAvailability | undefined {
    return this._requestedAvailability;
  }
  set requestedAvailability(value: RequestedAvailability | undefined) {
    this._requestedAvailability = value;
  }
  get attributeIds(): number[] {
    return this._attributeIds;
  }
  set attributeIds(value: number[]) {
    this._attributeIds = value;
  }
  get maxDistance(): googleType001.Decimal | undefined {
    return this._maxDistance;
  }
  set maxDistance(value: googleType001.Decimal | undefined) {
    this._maxDistance = value;
  }
  get sortBy(): SortBy {
    return this._sortBy;
  }
  set sortBy(value: SortBy) {
    this._sortBy = value;
  }
  get hasBenefits(): googleProtobuf000.BoolValue | undefined {
    return this._hasBenefits;
  }
  set hasBenefits(value: googleProtobuf000.BoolValue | undefined) {
    this._hasBenefits = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      locationId: this.locationId ? this.locationId.toObject() : undefined,
      geolocation: this.geolocation ? this.geolocation.toObject() : undefined,
      venueIds: (this.venueIds || []).slice(),
      pageSize: this.pageSize,
      availableOnly: this.availableOnly,
      requestedAvailability: this.requestedAvailability
        ? this.requestedAvailability.toObject()
        : undefined,
      attributeIds: (this.attributeIds || []).slice(),
      maxDistance: this.maxDistance ? this.maxDistance.toObject() : undefined,
      sortBy: this.sortBy,
      hasBenefits: this.hasBenefits ? this.hasBenefits.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      locationId: this.locationId
        ? this.locationId.toProtobufJSON(options)
        : null,
      geolocation: this.geolocation
        ? this.geolocation.toProtobufJSON(options)
        : null,
      venueIds: (this.venueIds || []).slice(),
      pageSize: this.pageSize,
      availableOnly: this.availableOnly,
      requestedAvailability: this.requestedAvailability
        ? this.requestedAvailability.toProtobufJSON(options)
        : null,
      attributeIds: (this.attributeIds || []).slice(),
      maxDistance: this.maxDistance
        ? this.maxDistance.toProtobufJSON(options)
        : null,
      sortBy:
        SortBy[
          this.sortBy === null || this.sortBy === undefined ? 0 : this.sortBy
        ],
      hasBenefits: this.hasBenefits
        ? this.hasBenefits.toProtobufJSON(options)
        : null
    };
  }
}
export module SearchRequest {
  /**
   * Standard JavaScript object representation for SearchRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    locationId?: googleProtobuf000.Int32Value.AsObject;
    geolocation?: booking_platformV1Shared002.Geolocation.AsObject;
    venueIds: number[];
    pageSize: number;
    availableOnly: boolean;
    requestedAvailability?: RequestedAvailability.AsObject;
    attributeIds: number[];
    maxDistance?: googleType001.Decimal.AsObject;
    sortBy: SortBy;
    hasBenefits?: googleProtobuf000.BoolValue.AsObject;
  }

  /**
   * Protobuf JSON representation for SearchRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    locationId: googleProtobuf000.Int32Value.AsProtobufJSON | null;
    geolocation: booking_platformV1Shared002.Geolocation.AsProtobufJSON | null;
    venueIds: number[];
    pageSize: number;
    availableOnly: boolean;
    requestedAvailability: RequestedAvailability.AsProtobufJSON | null;
    attributeIds: number[];
    maxDistance: googleType001.Decimal.AsProtobufJSON | null;
    sortBy: string;
    hasBenefits: googleProtobuf000.BoolValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.RequestedAvailability
 */
export class RequestedAvailability implements GrpcMessage {
  static id = 'booking_platform.v1.dining.RequestedAvailability';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RequestedAvailability();
    RequestedAvailability.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RequestedAvailability) {
    _instance.date = _instance.date || '';
    _instance.time = _instance.time || '';
    _instance.numberOfGuests = _instance.numberOfGuests || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RequestedAvailability,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.date = _reader.readString();
          break;
        case 2:
          _instance.time = _reader.readString();
          break;
        case 3:
          _instance.numberOfGuests = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    RequestedAvailability.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RequestedAvailability,
    _writer: BinaryWriter
  ) {
    if (_instance.date) {
      _writer.writeString(1, _instance.date);
    }
    if (_instance.time) {
      _writer.writeString(2, _instance.time);
    }
    if (_instance.numberOfGuests) {
      _writer.writeInt32(3, _instance.numberOfGuests);
    }
  }

  private _date: string;
  private _time: string;
  private _numberOfGuests: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RequestedAvailability to deeply clone from
   */
  constructor(_value?: RecursivePartial<RequestedAvailability.AsObject>) {
    _value = _value || {};
    this.date = _value.date;
    this.time = _value.time;
    this.numberOfGuests = _value.numberOfGuests;
    RequestedAvailability.refineValues(this);
  }
  get date(): string {
    return this._date;
  }
  set date(value: string) {
    this._date = value;
  }
  get time(): string {
    return this._time;
  }
  set time(value: string) {
    this._time = value;
  }
  get numberOfGuests(): number {
    return this._numberOfGuests;
  }
  set numberOfGuests(value: number) {
    this._numberOfGuests = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RequestedAvailability.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RequestedAvailability.AsObject {
    return {
      date: this.date,
      time: this.time,
      numberOfGuests: this.numberOfGuests
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RequestedAvailability.AsProtobufJSON {
    return {
      date: this.date,
      time: this.time,
      numberOfGuests: this.numberOfGuests
    };
  }
}
export module RequestedAvailability {
  /**
   * Standard JavaScript object representation for RequestedAvailability
   */
  export interface AsObject {
    date: string;
    time: string;
    numberOfGuests: number;
  }

  /**
   * Protobuf JSON representation for RequestedAvailability
   */
  export interface AsProtobufJSON {
    date: string;
    time: string;
    numberOfGuests: number;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.SearchResponse
 */
export class SearchResponse implements GrpcMessage {
  static id = 'booking_platform.v1.dining.SearchResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchResponse();
    SearchResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchResponse) {
    _instance.searchToken = _instance.searchToken || undefined;
    _instance.venues = _instance.venues || [];
    _instance.allAttributeIds = _instance.allAttributeIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.searchToken = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.searchToken,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 2:
          const messageInitializer2 = new VenueItem();
          _reader.readMessage(
            messageInitializer2,
            VenueItem.deserializeBinaryFromReader
          );
          (_instance.venues = _instance.venues || []).push(messageInitializer2);
          break;
        case 3:
          (_instance.allAttributeIds = _instance.allAttributeIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SearchResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.searchToken) {
      _writer.writeMessage(
        1,
        _instance.searchToken as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.venues && _instance.venues.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.venues as any,
        VenueItem.serializeBinaryToWriter
      );
    }
    if (_instance.allAttributeIds && _instance.allAttributeIds.length) {
      _writer.writePackedInt32(3, _instance.allAttributeIds);
    }
  }

  private _searchToken?: googleProtobuf000.StringValue;
  private _venues?: VenueItem[];
  private _allAttributeIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchResponse.AsObject>) {
    _value = _value || {};
    this.searchToken = _value.searchToken
      ? new googleProtobuf000.StringValue(_value.searchToken)
      : undefined;
    this.venues = (_value.venues || []).map(m => new VenueItem(m));
    this.allAttributeIds = (_value.allAttributeIds || []).slice();
    SearchResponse.refineValues(this);
  }
  get searchToken(): googleProtobuf000.StringValue | undefined {
    return this._searchToken;
  }
  set searchToken(value: googleProtobuf000.StringValue | undefined) {
    this._searchToken = value;
  }
  get venues(): VenueItem[] | undefined {
    return this._venues;
  }
  set venues(value: VenueItem[] | undefined) {
    this._venues = value;
  }
  get allAttributeIds(): number[] {
    return this._allAttributeIds;
  }
  set allAttributeIds(value: number[]) {
    this._allAttributeIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchResponse.AsObject {
    return {
      searchToken: this.searchToken ? this.searchToken.toObject() : undefined,
      venues: (this.venues || []).map(m => m.toObject()),
      allAttributeIds: (this.allAttributeIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchResponse.AsProtobufJSON {
    return {
      searchToken: this.searchToken
        ? this.searchToken.toProtobufJSON(options)
        : null,
      venues: (this.venues || []).map(m => m.toProtobufJSON(options)),
      allAttributeIds: (this.allAttributeIds || []).slice()
    };
  }
}
export module SearchResponse {
  /**
   * Standard JavaScript object representation for SearchResponse
   */
  export interface AsObject {
    searchToken?: googleProtobuf000.StringValue.AsObject;
    venues?: VenueItem.AsObject[];
    allAttributeIds: number[];
  }

  /**
   * Protobuf JSON representation for SearchResponse
   */
  export interface AsProtobufJSON {
    searchToken: googleProtobuf000.StringValue.AsProtobufJSON | null;
    venues: VenueItem.AsProtobufJSON[] | null;
    allAttributeIds: number[];
  }
}

/**
 * Message implementation for booking_platform.v1.dining.VenueItem
 */
export class VenueItem implements GrpcMessage {
  static id = 'booking_platform.v1.dining.VenueItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueItem();
    VenueItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueItem) {
    _instance.venueId = _instance.venueId || 0;
    _instance.venueName = _instance.venueName || '';
    _instance.location = _instance.location || '';
    _instance.attributeIds = _instance.attributeIds || [];
    _instance.imageUrl = _instance.imageUrl || undefined;
    _instance.availabilityStatus = _instance.availabilityStatus || 0;
    _instance.ranking = _instance.ranking || undefined;
    _instance.distance = _instance.distance || undefined;
    _instance.timeSlots = _instance.timeSlots || [];
    _instance.order = _instance.order || 0;
    _instance.hasBenefits = _instance.hasBenefits || false;
    _instance.geolocation = _instance.geolocation || undefined;
    _instance.currencyCode = _instance.currencyCode || undefined;
    _instance.locationName = _instance.locationName || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.venueId = _reader.readInt32();
          break;
        case 2:
          _instance.venueName = _reader.readString();
          break;
        case 3:
          _instance.location = _reader.readString();
          break;
        case 4:
          (_instance.attributeIds = _instance.attributeIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        case 6:
          _instance.imageUrl = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.imageUrl,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.availabilityStatus = _reader.readEnum();
          break;
        case 8:
          _instance.ranking = new googleType001.Decimal();
          _reader.readMessage(
            _instance.ranking,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.distance = new googleType001.Decimal();
          _reader.readMessage(
            _instance.distance,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 10:
          const messageInitializer10 = new TimeSlot();
          _reader.readMessage(
            messageInitializer10,
            TimeSlot.deserializeBinaryFromReader
          );
          (_instance.timeSlots = _instance.timeSlots || []).push(
            messageInitializer10
          );
          break;
        case 11:
          _instance.order = _reader.readInt32();
          break;
        case 12:
          _instance.hasBenefits = _reader.readBool();
          break;
        case 13:
          _instance.geolocation = new booking_platformV1Shared002.Geolocation();
          _reader.readMessage(
            _instance.geolocation,
            booking_platformV1Shared002.Geolocation.deserializeBinaryFromReader
          );
          break;
        case 14:
          _instance.currencyCode = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.currencyCode,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 15:
          _instance.locationName = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    VenueItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: VenueItem, _writer: BinaryWriter) {
    if (_instance.venueId) {
      _writer.writeInt32(1, _instance.venueId);
    }
    if (_instance.venueName) {
      _writer.writeString(2, _instance.venueName);
    }
    if (_instance.location) {
      _writer.writeString(3, _instance.location);
    }
    if (_instance.attributeIds && _instance.attributeIds.length) {
      _writer.writePackedInt32(4, _instance.attributeIds);
    }
    if (_instance.imageUrl) {
      _writer.writeMessage(
        6,
        _instance.imageUrl as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.availabilityStatus) {
      _writer.writeEnum(7, _instance.availabilityStatus);
    }
    if (_instance.ranking) {
      _writer.writeMessage(
        8,
        _instance.ranking as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.distance) {
      _writer.writeMessage(
        9,
        _instance.distance as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.timeSlots && _instance.timeSlots.length) {
      _writer.writeRepeatedMessage(
        10,
        _instance.timeSlots as any,
        TimeSlot.serializeBinaryToWriter
      );
    }
    if (_instance.order) {
      _writer.writeInt32(11, _instance.order);
    }
    if (_instance.hasBenefits) {
      _writer.writeBool(12, _instance.hasBenefits);
    }
    if (_instance.geolocation) {
      _writer.writeMessage(
        13,
        _instance.geolocation as any,
        booking_platformV1Shared002.Geolocation.serializeBinaryToWriter
      );
    }
    if (_instance.currencyCode) {
      _writer.writeMessage(
        14,
        _instance.currencyCode as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.locationName) {
      _writer.writeString(15, _instance.locationName);
    }
  }

  private _venueId: number;
  private _venueName: string;
  private _location: string;
  private _attributeIds: number[];
  private _imageUrl?: googleProtobuf000.StringValue;
  private _availabilityStatus: AvailabilityStatus;
  private _ranking?: googleType001.Decimal;
  private _distance?: googleType001.Decimal;
  private _timeSlots?: TimeSlot[];
  private _order: number;
  private _hasBenefits: boolean;
  private _geolocation?: booking_platformV1Shared002.Geolocation;
  private _currencyCode?: googleProtobuf000.StringValue;
  private _locationName: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueItem.AsObject>) {
    _value = _value || {};
    this.venueId = _value.venueId;
    this.venueName = _value.venueName;
    this.location = _value.location;
    this.attributeIds = (_value.attributeIds || []).slice();
    this.imageUrl = _value.imageUrl
      ? new googleProtobuf000.StringValue(_value.imageUrl)
      : undefined;
    this.availabilityStatus = _value.availabilityStatus;
    this.ranking = _value.ranking
      ? new googleType001.Decimal(_value.ranking)
      : undefined;
    this.distance = _value.distance
      ? new googleType001.Decimal(_value.distance)
      : undefined;
    this.timeSlots = (_value.timeSlots || []).map(m => new TimeSlot(m));
    this.order = _value.order;
    this.hasBenefits = _value.hasBenefits;
    this.geolocation = _value.geolocation
      ? new booking_platformV1Shared002.Geolocation(_value.geolocation)
      : undefined;
    this.currencyCode = _value.currencyCode
      ? new googleProtobuf000.StringValue(_value.currencyCode)
      : undefined;
    this.locationName = _value.locationName;
    VenueItem.refineValues(this);
  }
  get venueId(): number {
    return this._venueId;
  }
  set venueId(value: number) {
    this._venueId = value;
  }
  get venueName(): string {
    return this._venueName;
  }
  set venueName(value: string) {
    this._venueName = value;
  }
  get location(): string {
    return this._location;
  }
  set location(value: string) {
    this._location = value;
  }
  get attributeIds(): number[] {
    return this._attributeIds;
  }
  set attributeIds(value: number[]) {
    this._attributeIds = value;
  }
  get imageUrl(): googleProtobuf000.StringValue | undefined {
    return this._imageUrl;
  }
  set imageUrl(value: googleProtobuf000.StringValue | undefined) {
    this._imageUrl = value;
  }
  get availabilityStatus(): AvailabilityStatus {
    return this._availabilityStatus;
  }
  set availabilityStatus(value: AvailabilityStatus) {
    this._availabilityStatus = value;
  }
  get ranking(): googleType001.Decimal | undefined {
    return this._ranking;
  }
  set ranking(value: googleType001.Decimal | undefined) {
    this._ranking = value;
  }
  get distance(): googleType001.Decimal | undefined {
    return this._distance;
  }
  set distance(value: googleType001.Decimal | undefined) {
    this._distance = value;
  }
  get timeSlots(): TimeSlot[] | undefined {
    return this._timeSlots;
  }
  set timeSlots(value: TimeSlot[] | undefined) {
    this._timeSlots = value;
  }
  get order(): number {
    return this._order;
  }
  set order(value: number) {
    this._order = value;
  }
  get hasBenefits(): boolean {
    return this._hasBenefits;
  }
  set hasBenefits(value: boolean) {
    this._hasBenefits = value;
  }
  get geolocation(): booking_platformV1Shared002.Geolocation | undefined {
    return this._geolocation;
  }
  set geolocation(value: booking_platformV1Shared002.Geolocation | undefined) {
    this._geolocation = value;
  }
  get currencyCode(): googleProtobuf000.StringValue | undefined {
    return this._currencyCode;
  }
  set currencyCode(value: googleProtobuf000.StringValue | undefined) {
    this._currencyCode = value;
  }
  get locationName(): string {
    return this._locationName;
  }
  set locationName(value: string) {
    this._locationName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueItem.AsObject {
    return {
      venueId: this.venueId,
      venueName: this.venueName,
      location: this.location,
      attributeIds: (this.attributeIds || []).slice(),
      imageUrl: this.imageUrl ? this.imageUrl.toObject() : undefined,
      availabilityStatus: this.availabilityStatus,
      ranking: this.ranking ? this.ranking.toObject() : undefined,
      distance: this.distance ? this.distance.toObject() : undefined,
      timeSlots: (this.timeSlots || []).map(m => m.toObject()),
      order: this.order,
      hasBenefits: this.hasBenefits,
      geolocation: this.geolocation ? this.geolocation.toObject() : undefined,
      currencyCode: this.currencyCode
        ? this.currencyCode.toObject()
        : undefined,
      locationName: this.locationName
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueItem.AsProtobufJSON {
    return {
      venueId: this.venueId,
      venueName: this.venueName,
      location: this.location,
      attributeIds: (this.attributeIds || []).slice(),
      imageUrl: this.imageUrl ? this.imageUrl.toProtobufJSON(options) : null,
      availabilityStatus:
        AvailabilityStatus[
          this.availabilityStatus === null ||
          this.availabilityStatus === undefined
            ? 0
            : this.availabilityStatus
        ],
      ranking: this.ranking ? this.ranking.toProtobufJSON(options) : null,
      distance: this.distance ? this.distance.toProtobufJSON(options) : null,
      timeSlots: (this.timeSlots || []).map(m => m.toProtobufJSON(options)),
      order: this.order,
      hasBenefits: this.hasBenefits,
      geolocation: this.geolocation
        ? this.geolocation.toProtobufJSON(options)
        : null,
      currencyCode: this.currencyCode
        ? this.currencyCode.toProtobufJSON(options)
        : null,
      locationName: this.locationName
    };
  }
}
export module VenueItem {
  /**
   * Standard JavaScript object representation for VenueItem
   */
  export interface AsObject {
    venueId: number;
    venueName: string;
    location: string;
    attributeIds: number[];
    imageUrl?: googleProtobuf000.StringValue.AsObject;
    availabilityStatus: AvailabilityStatus;
    ranking?: googleType001.Decimal.AsObject;
    distance?: googleType001.Decimal.AsObject;
    timeSlots?: TimeSlot.AsObject[];
    order: number;
    hasBenefits: boolean;
    geolocation?: booking_platformV1Shared002.Geolocation.AsObject;
    currencyCode?: googleProtobuf000.StringValue.AsObject;
    locationName: string;
  }

  /**
   * Protobuf JSON representation for VenueItem
   */
  export interface AsProtobufJSON {
    venueId: number;
    venueName: string;
    location: string;
    attributeIds: number[];
    imageUrl: googleProtobuf000.StringValue.AsProtobufJSON | null;
    availabilityStatus: string;
    ranking: googleType001.Decimal.AsProtobufJSON | null;
    distance: googleType001.Decimal.AsProtobufJSON | null;
    timeSlots: TimeSlot.AsProtobufJSON[] | null;
    order: number;
    hasBenefits: boolean;
    geolocation: booking_platformV1Shared002.Geolocation.AsProtobufJSON | null;
    currencyCode: googleProtobuf000.StringValue.AsProtobufJSON | null;
    locationName: string;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.SearchNextPageRequest
 */
export class SearchNextPageRequest implements GrpcMessage {
  static id = 'booking_platform.v1.dining.SearchNextPageRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchNextPageRequest();
    SearchNextPageRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchNextPageRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.searchToken = _instance.searchToken || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchNextPageRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.searchToken = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    SearchNextPageRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchNextPageRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.searchToken) {
      _writer.writeString(4, _instance.searchToken);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _searchToken: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchNextPageRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchNextPageRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.searchToken = _value.searchToken;
    SearchNextPageRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get searchToken(): string {
    return this._searchToken;
  }
  set searchToken(value: string) {
    this._searchToken = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchNextPageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchNextPageRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      searchToken: this.searchToken
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchNextPageRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      searchToken: this.searchToken
    };
  }
}
export module SearchNextPageRequest {
  /**
   * Standard JavaScript object representation for SearchNextPageRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    searchToken: string;
  }

  /**
   * Protobuf JSON representation for SearchNextPageRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    searchToken: string;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.AutocompleteRequest
 */
export class AutocompleteRequest implements GrpcMessage {
  static id = 'booking_platform.v1.dining.AutocompleteRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutocompleteRequest();
    AutocompleteRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutocompleteRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.categories = _instance.categories || [];
    _instance.searchString = _instance.searchString || '';
    _instance.geolocation = _instance.geolocation || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutocompleteRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          (_instance.categories = _instance.categories || []).push(
            ...(_reader.readPackedEnum() || [])
          );
          break;
        case 6:
          _instance.searchString = _reader.readString();
          break;
        case 7:
          _instance.geolocation = new booking_platformV1Shared002.Geolocation();
          _reader.readMessage(
            _instance.geolocation,
            booking_platformV1Shared002.Geolocation.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AutocompleteRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutocompleteRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.categories && _instance.categories.length) {
      _writer.writePackedEnum(5, _instance.categories);
    }
    if (_instance.searchString) {
      _writer.writeString(6, _instance.searchString);
    }
    if (_instance.geolocation) {
      _writer.writeMessage(
        7,
        _instance.geolocation as any,
        booking_platformV1Shared002.Geolocation.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _categories: AutocompleteCategory[];
  private _searchString: string;
  private _geolocation?: booking_platformV1Shared002.Geolocation;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutocompleteRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AutocompleteRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.categories = (_value.categories || []).slice();
    this.searchString = _value.searchString;
    this.geolocation = _value.geolocation
      ? new booking_platformV1Shared002.Geolocation(_value.geolocation)
      : undefined;
    AutocompleteRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get categories(): AutocompleteCategory[] {
    return this._categories;
  }
  set categories(value: AutocompleteCategory[]) {
    this._categories = value;
  }
  get searchString(): string {
    return this._searchString;
  }
  set searchString(value: string) {
    this._searchString = value;
  }
  get geolocation(): booking_platformV1Shared002.Geolocation | undefined {
    return this._geolocation;
  }
  set geolocation(value: booking_platformV1Shared002.Geolocation | undefined) {
    this._geolocation = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutocompleteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutocompleteRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      categories: (this.categories || []).slice(),
      searchString: this.searchString,
      geolocation: this.geolocation ? this.geolocation.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutocompleteRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      categories: (this.categories || []).map(v => AutocompleteCategory[v]),
      searchString: this.searchString,
      geolocation: this.geolocation
        ? this.geolocation.toProtobufJSON(options)
        : null
    };
  }
}
export module AutocompleteRequest {
  /**
   * Standard JavaScript object representation for AutocompleteRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    categories: AutocompleteCategory[];
    searchString: string;
    geolocation?: booking_platformV1Shared002.Geolocation.AsObject;
  }

  /**
   * Protobuf JSON representation for AutocompleteRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    categories: string[];
    searchString: string;
    geolocation: booking_platformV1Shared002.Geolocation.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.AutoCompleteResultByCategory
 */
export class AutoCompleteResultByCategory implements GrpcMessage {
  static id = 'booking_platform.v1.dining.AutoCompleteResultByCategory';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutoCompleteResultByCategory();
    AutoCompleteResultByCategory.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutoCompleteResultByCategory) {
    _instance.category = _instance.category || 0;
    _instance.results = _instance.results || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutoCompleteResultByCategory,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.category = _reader.readEnum();
          break;
        case 2:
          const messageInitializer2 = new booking_platformV1Shared003.AutoCompleteResultItem();
          _reader.readMessage(
            messageInitializer2,
            booking_platformV1Shared003.AutoCompleteResultItem
              .deserializeBinaryFromReader
          );
          (_instance.results = _instance.results || []).push(
            messageInitializer2
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AutoCompleteResultByCategory.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutoCompleteResultByCategory,
    _writer: BinaryWriter
  ) {
    if (_instance.category) {
      _writer.writeEnum(1, _instance.category);
    }
    if (_instance.results && _instance.results.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.results as any,
        booking_platformV1Shared003.AutoCompleteResultItem
          .serializeBinaryToWriter
      );
    }
  }

  private _category: AutocompleteCategory;
  private _results?: booking_platformV1Shared003.AutoCompleteResultItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutoCompleteResultByCategory to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<AutoCompleteResultByCategory.AsObject>
  ) {
    _value = _value || {};
    this.category = _value.category;
    this.results = (_value.results || []).map(
      m => new booking_platformV1Shared003.AutoCompleteResultItem(m)
    );
    AutoCompleteResultByCategory.refineValues(this);
  }
  get category(): AutocompleteCategory {
    return this._category;
  }
  set category(value: AutocompleteCategory) {
    this._category = value;
  }
  get results():
    | booking_platformV1Shared003.AutoCompleteResultItem[]
    | undefined {
    return this._results;
  }
  set results(
    value: booking_platformV1Shared003.AutoCompleteResultItem[] | undefined
  ) {
    this._results = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutoCompleteResultByCategory.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutoCompleteResultByCategory.AsObject {
    return {
      category: this.category,
      results: (this.results || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutoCompleteResultByCategory.AsProtobufJSON {
    return {
      category:
        AutocompleteCategory[
          this.category === null || this.category === undefined
            ? 0
            : this.category
        ],
      results: (this.results || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AutoCompleteResultByCategory {
  /**
   * Standard JavaScript object representation for AutoCompleteResultByCategory
   */
  export interface AsObject {
    category: AutocompleteCategory;
    results?: booking_platformV1Shared003.AutoCompleteResultItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for AutoCompleteResultByCategory
   */
  export interface AsProtobufJSON {
    category: string;
    results:
      | booking_platformV1Shared003.AutoCompleteResultItem.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.AutocompleteResponse
 */
export class AutocompleteResponse implements GrpcMessage {
  static id = 'booking_platform.v1.dining.AutocompleteResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutocompleteResponse();
    AutocompleteResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutocompleteResponse) {
    _instance.categories = _instance.categories || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutocompleteResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AutoCompleteResultByCategory();
          _reader.readMessage(
            messageInitializer1,
            AutoCompleteResultByCategory.deserializeBinaryFromReader
          );
          (_instance.categories = _instance.categories || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AutocompleteResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutocompleteResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.categories && _instance.categories.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.categories as any,
        AutoCompleteResultByCategory.serializeBinaryToWriter
      );
    }
  }

  private _categories?: AutoCompleteResultByCategory[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutocompleteResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AutocompleteResponse.AsObject>) {
    _value = _value || {};
    this.categories = (_value.categories || []).map(
      m => new AutoCompleteResultByCategory(m)
    );
    AutocompleteResponse.refineValues(this);
  }
  get categories(): AutoCompleteResultByCategory[] | undefined {
    return this._categories;
  }
  set categories(value: AutoCompleteResultByCategory[] | undefined) {
    this._categories = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutocompleteResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutocompleteResponse.AsObject {
    return {
      categories: (this.categories || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutocompleteResponse.AsProtobufJSON {
    return {
      categories: (this.categories || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AutocompleteResponse {
  /**
   * Standard JavaScript object representation for AutocompleteResponse
   */
  export interface AsObject {
    categories?: AutoCompleteResultByCategory.AsObject[];
  }

  /**
   * Protobuf JSON representation for AutocompleteResponse
   */
  export interface AsProtobufJSON {
    categories: AutoCompleteResultByCategory.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.GetVenueAvailabilitiesRequest
 */
export class GetVenueAvailabilitiesRequest implements GrpcMessage {
  static id = 'booking_platform.v1.dining.GetVenueAvailabilitiesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetVenueAvailabilitiesRequest();
    GetVenueAvailabilitiesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetVenueAvailabilitiesRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.venueIds = _instance.venueIds || [];
    _instance.date = _instance.date || '';
    _instance.time = _instance.time || undefined;
    _instance.startTime = _instance.startTime || undefined;
    _instance.endTime = _instance.endTime || undefined;
    _instance.numberOfGuests = _instance.numberOfGuests || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetVenueAvailabilitiesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          (_instance.venueIds = _instance.venueIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        case 5:
          _instance.date = _reader.readString();
          break;
        case 6:
          _instance.time = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.time,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.startTime = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.startTime,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.endTime = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.endTime,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.numberOfGuests = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetVenueAvailabilitiesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetVenueAvailabilitiesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.venueIds && _instance.venueIds.length) {
      _writer.writePackedInt32(4, _instance.venueIds);
    }
    if (_instance.date) {
      _writer.writeString(5, _instance.date);
    }
    if (_instance.time) {
      _writer.writeMessage(
        6,
        _instance.time as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.startTime) {
      _writer.writeMessage(
        7,
        _instance.startTime as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.endTime) {
      _writer.writeMessage(
        8,
        _instance.endTime as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.numberOfGuests) {
      _writer.writeInt32(9, _instance.numberOfGuests);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _venueIds: number[];
  private _date: string;
  private _time?: googleProtobuf000.StringValue;
  private _startTime?: googleProtobuf000.StringValue;
  private _endTime?: googleProtobuf000.StringValue;
  private _numberOfGuests: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetVenueAvailabilitiesRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetVenueAvailabilitiesRequest.AsObject>
  ) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.venueIds = (_value.venueIds || []).slice();
    this.date = _value.date;
    this.time = _value.time
      ? new googleProtobuf000.StringValue(_value.time)
      : undefined;
    this.startTime = _value.startTime
      ? new googleProtobuf000.StringValue(_value.startTime)
      : undefined;
    this.endTime = _value.endTime
      ? new googleProtobuf000.StringValue(_value.endTime)
      : undefined;
    this.numberOfGuests = _value.numberOfGuests;
    GetVenueAvailabilitiesRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get venueIds(): number[] {
    return this._venueIds;
  }
  set venueIds(value: number[]) {
    this._venueIds = value;
  }
  get date(): string {
    return this._date;
  }
  set date(value: string) {
    this._date = value;
  }
  get time(): googleProtobuf000.StringValue | undefined {
    return this._time;
  }
  set time(value: googleProtobuf000.StringValue | undefined) {
    this._time = value;
  }
  get startTime(): googleProtobuf000.StringValue | undefined {
    return this._startTime;
  }
  set startTime(value: googleProtobuf000.StringValue | undefined) {
    this._startTime = value;
  }
  get endTime(): googleProtobuf000.StringValue | undefined {
    return this._endTime;
  }
  set endTime(value: googleProtobuf000.StringValue | undefined) {
    this._endTime = value;
  }
  get numberOfGuests(): number {
    return this._numberOfGuests;
  }
  set numberOfGuests(value: number) {
    this._numberOfGuests = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetVenueAvailabilitiesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetVenueAvailabilitiesRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      venueIds: (this.venueIds || []).slice(),
      date: this.date,
      time: this.time ? this.time.toObject() : undefined,
      startTime: this.startTime ? this.startTime.toObject() : undefined,
      endTime: this.endTime ? this.endTime.toObject() : undefined,
      numberOfGuests: this.numberOfGuests
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetVenueAvailabilitiesRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      venueIds: (this.venueIds || []).slice(),
      date: this.date,
      time: this.time ? this.time.toProtobufJSON(options) : null,
      startTime: this.startTime ? this.startTime.toProtobufJSON(options) : null,
      endTime: this.endTime ? this.endTime.toProtobufJSON(options) : null,
      numberOfGuests: this.numberOfGuests
    };
  }
}
export module GetVenueAvailabilitiesRequest {
  /**
   * Standard JavaScript object representation for GetVenueAvailabilitiesRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    venueIds: number[];
    date: string;
    time?: googleProtobuf000.StringValue.AsObject;
    startTime?: googleProtobuf000.StringValue.AsObject;
    endTime?: googleProtobuf000.StringValue.AsObject;
    numberOfGuests: number;
  }

  /**
   * Protobuf JSON representation for GetVenueAvailabilitiesRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    venueIds: number[];
    date: string;
    time: googleProtobuf000.StringValue.AsProtobufJSON | null;
    startTime: googleProtobuf000.StringValue.AsProtobufJSON | null;
    endTime: googleProtobuf000.StringValue.AsProtobufJSON | null;
    numberOfGuests: number;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.GetVenueAvailabilitiesResponse
 */
export class GetVenueAvailabilitiesResponse implements GrpcMessage {
  static id = 'booking_platform.v1.dining.GetVenueAvailabilitiesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetVenueAvailabilitiesResponse();
    GetVenueAvailabilitiesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetVenueAvailabilitiesResponse) {
    _instance.venues = _instance.venues || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetVenueAvailabilitiesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new VenueAvailabilityItem();
          _reader.readMessage(
            messageInitializer1,
            VenueAvailabilityItem.deserializeBinaryFromReader
          );
          (_instance.venues = _instance.venues || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    GetVenueAvailabilitiesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetVenueAvailabilitiesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.venues && _instance.venues.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.venues as any,
        VenueAvailabilityItem.serializeBinaryToWriter
      );
    }
  }

  private _venues?: VenueAvailabilityItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetVenueAvailabilitiesResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetVenueAvailabilitiesResponse.AsObject>
  ) {
    _value = _value || {};
    this.venues = (_value.venues || []).map(m => new VenueAvailabilityItem(m));
    GetVenueAvailabilitiesResponse.refineValues(this);
  }
  get venues(): VenueAvailabilityItem[] | undefined {
    return this._venues;
  }
  set venues(value: VenueAvailabilityItem[] | undefined) {
    this._venues = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetVenueAvailabilitiesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetVenueAvailabilitiesResponse.AsObject {
    return {
      venues: (this.venues || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetVenueAvailabilitiesResponse.AsProtobufJSON {
    return {
      venues: (this.venues || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module GetVenueAvailabilitiesResponse {
  /**
   * Standard JavaScript object representation for GetVenueAvailabilitiesResponse
   */
  export interface AsObject {
    venues?: VenueAvailabilityItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetVenueAvailabilitiesResponse
   */
  export interface AsProtobufJSON {
    venues: VenueAvailabilityItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.VenueAvailabilityItem
 */
export class VenueAvailabilityItem implements GrpcMessage {
  static id = 'booking_platform.v1.dining.VenueAvailabilityItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueAvailabilityItem();
    VenueAvailabilityItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueAvailabilityItem) {
    _instance.venueId = _instance.venueId || 0;
    _instance.availabilityStatus = _instance.availabilityStatus || 0;
    _instance.timeSlots = _instance.timeSlots || [];
    _instance.currencyCode = _instance.currencyCode || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueAvailabilityItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.venueId = _reader.readInt32();
          break;
        case 2:
          _instance.availabilityStatus = _reader.readEnum();
          break;
        case 3:
          const messageInitializer3 = new TimeSlot();
          _reader.readMessage(
            messageInitializer3,
            TimeSlot.deserializeBinaryFromReader
          );
          (_instance.timeSlots = _instance.timeSlots || []).push(
            messageInitializer3
          );
          break;
        case 4:
          _instance.currencyCode = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    VenueAvailabilityItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueAvailabilityItem,
    _writer: BinaryWriter
  ) {
    if (_instance.venueId) {
      _writer.writeInt32(1, _instance.venueId);
    }
    if (_instance.availabilityStatus) {
      _writer.writeEnum(2, _instance.availabilityStatus);
    }
    if (_instance.timeSlots && _instance.timeSlots.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.timeSlots as any,
        TimeSlot.serializeBinaryToWriter
      );
    }
    if (_instance.currencyCode) {
      _writer.writeString(4, _instance.currencyCode);
    }
  }

  private _venueId: number;
  private _availabilityStatus: AvailabilityStatus;
  private _timeSlots?: TimeSlot[];
  private _currencyCode: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueAvailabilityItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueAvailabilityItem.AsObject>) {
    _value = _value || {};
    this.venueId = _value.venueId;
    this.availabilityStatus = _value.availabilityStatus;
    this.timeSlots = (_value.timeSlots || []).map(m => new TimeSlot(m));
    this.currencyCode = _value.currencyCode;
    VenueAvailabilityItem.refineValues(this);
  }
  get venueId(): number {
    return this._venueId;
  }
  set venueId(value: number) {
    this._venueId = value;
  }
  get availabilityStatus(): AvailabilityStatus {
    return this._availabilityStatus;
  }
  set availabilityStatus(value: AvailabilityStatus) {
    this._availabilityStatus = value;
  }
  get timeSlots(): TimeSlot[] | undefined {
    return this._timeSlots;
  }
  set timeSlots(value: TimeSlot[] | undefined) {
    this._timeSlots = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueAvailabilityItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueAvailabilityItem.AsObject {
    return {
      venueId: this.venueId,
      availabilityStatus: this.availabilityStatus,
      timeSlots: (this.timeSlots || []).map(m => m.toObject()),
      currencyCode: this.currencyCode
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueAvailabilityItem.AsProtobufJSON {
    return {
      venueId: this.venueId,
      availabilityStatus:
        AvailabilityStatus[
          this.availabilityStatus === null ||
          this.availabilityStatus === undefined
            ? 0
            : this.availabilityStatus
        ],
      timeSlots: (this.timeSlots || []).map(m => m.toProtobufJSON(options)),
      currencyCode: this.currencyCode
    };
  }
}
export module VenueAvailabilityItem {
  /**
   * Standard JavaScript object representation for VenueAvailabilityItem
   */
  export interface AsObject {
    venueId: number;
    availabilityStatus: AvailabilityStatus;
    timeSlots?: TimeSlot.AsObject[];
    currencyCode: string;
  }

  /**
   * Protobuf JSON representation for VenueAvailabilityItem
   */
  export interface AsProtobufJSON {
    venueId: number;
    availabilityStatus: string;
    timeSlots: TimeSlot.AsProtobufJSON[] | null;
    currencyCode: string;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.TimeSlot
 */
export class TimeSlot implements GrpcMessage {
  static id = 'booking_platform.v1.dining.TimeSlot';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TimeSlot();
    TimeSlot.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TimeSlot) {
    _instance.time = _instance.time || '';
    _instance.slotType = _instance.slotType || undefined;
    _instance.paymentRule = _instance.paymentRule || 0;
    _instance.totalReserveCost = _instance.totalReserveCost || undefined;
    _instance.pregratuityTotal = _instance.pregratuityTotal || undefined;
    _instance.mandatedGratuityAmount =
      _instance.mandatedGratuityAmount || undefined;
    _instance.gratuity = _instance.gratuity || undefined;
    _instance.subTotal = _instance.subTotal || undefined;
    _instance.taxAmount = _instance.taxAmount || undefined;
    _instance.serviceChargeAmount = _instance.serviceChargeAmount || undefined;
    _instance.bookingToken = _instance.bookingToken || undefined;
    _instance.cancellationPolicy = _instance.cancellationPolicy || undefined;
    _instance.bookingPolicy = _instance.bookingPolicy || undefined;
    _instance.slotAttribute = _instance.slotAttribute || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TimeSlot,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.time = _reader.readString();
          break;
        case 2:
          _instance.slotType = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.slotType,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.paymentRule = _reader.readEnum();
          break;
        case 4:
          _instance.totalReserveCost = new googleType001.Decimal();
          _reader.readMessage(
            _instance.totalReserveCost,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.pregratuityTotal = new googleType001.Decimal();
          _reader.readMessage(
            _instance.pregratuityTotal,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.mandatedGratuityAmount = new googleType001.Decimal();
          _reader.readMessage(
            _instance.mandatedGratuityAmount,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.gratuity = new googleType001.Decimal();
          _reader.readMessage(
            _instance.gratuity,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.subTotal = new googleType001.Decimal();
          _reader.readMessage(
            _instance.subTotal,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.taxAmount = new googleType001.Decimal();
          _reader.readMessage(
            _instance.taxAmount,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 10:
          _instance.serviceChargeAmount = new googleType001.Decimal();
          _reader.readMessage(
            _instance.serviceChargeAmount,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.bookingToken = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.bookingToken,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 12:
          _instance.cancellationPolicy = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.cancellationPolicy,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 13:
          _instance.bookingPolicy = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.bookingPolicy,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 14:
          _instance.slotAttribute = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.slotAttribute,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    TimeSlot.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: TimeSlot, _writer: BinaryWriter) {
    if (_instance.time) {
      _writer.writeString(1, _instance.time);
    }
    if (_instance.slotType) {
      _writer.writeMessage(
        2,
        _instance.slotType as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.paymentRule) {
      _writer.writeEnum(3, _instance.paymentRule);
    }
    if (_instance.totalReserveCost) {
      _writer.writeMessage(
        4,
        _instance.totalReserveCost as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.pregratuityTotal) {
      _writer.writeMessage(
        5,
        _instance.pregratuityTotal as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.mandatedGratuityAmount) {
      _writer.writeMessage(
        6,
        _instance.mandatedGratuityAmount as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.gratuity) {
      _writer.writeMessage(
        7,
        _instance.gratuity as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.subTotal) {
      _writer.writeMessage(
        8,
        _instance.subTotal as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.taxAmount) {
      _writer.writeMessage(
        9,
        _instance.taxAmount as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.serviceChargeAmount) {
      _writer.writeMessage(
        10,
        _instance.serviceChargeAmount as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.bookingToken) {
      _writer.writeMessage(
        11,
        _instance.bookingToken as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.cancellationPolicy) {
      _writer.writeMessage(
        12,
        _instance.cancellationPolicy as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.bookingPolicy) {
      _writer.writeMessage(
        13,
        _instance.bookingPolicy as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.slotAttribute) {
      _writer.writeMessage(
        14,
        _instance.slotAttribute as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _time: string;
  private _slotType?: googleProtobuf000.StringValue;
  private _paymentRule: PaymentRule;
  private _totalReserveCost?: googleType001.Decimal;
  private _pregratuityTotal?: googleType001.Decimal;
  private _mandatedGratuityAmount?: googleType001.Decimal;
  private _gratuity?: googleType001.Decimal;
  private _subTotal?: googleType001.Decimal;
  private _taxAmount?: googleType001.Decimal;
  private _serviceChargeAmount?: googleType001.Decimal;
  private _bookingToken?: googleProtobuf000.StringValue;
  private _cancellationPolicy?: googleProtobuf000.StringValue;
  private _bookingPolicy?: googleProtobuf000.StringValue;
  private _slotAttribute?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TimeSlot to deeply clone from
   */
  constructor(_value?: RecursivePartial<TimeSlot.AsObject>) {
    _value = _value || {};
    this.time = _value.time;
    this.slotType = _value.slotType
      ? new googleProtobuf000.StringValue(_value.slotType)
      : undefined;
    this.paymentRule = _value.paymentRule;
    this.totalReserveCost = _value.totalReserveCost
      ? new googleType001.Decimal(_value.totalReserveCost)
      : undefined;
    this.pregratuityTotal = _value.pregratuityTotal
      ? new googleType001.Decimal(_value.pregratuityTotal)
      : undefined;
    this.mandatedGratuityAmount = _value.mandatedGratuityAmount
      ? new googleType001.Decimal(_value.mandatedGratuityAmount)
      : undefined;
    this.gratuity = _value.gratuity
      ? new googleType001.Decimal(_value.gratuity)
      : undefined;
    this.subTotal = _value.subTotal
      ? new googleType001.Decimal(_value.subTotal)
      : undefined;
    this.taxAmount = _value.taxAmount
      ? new googleType001.Decimal(_value.taxAmount)
      : undefined;
    this.serviceChargeAmount = _value.serviceChargeAmount
      ? new googleType001.Decimal(_value.serviceChargeAmount)
      : undefined;
    this.bookingToken = _value.bookingToken
      ? new googleProtobuf000.StringValue(_value.bookingToken)
      : undefined;
    this.cancellationPolicy = _value.cancellationPolicy
      ? new googleProtobuf000.StringValue(_value.cancellationPolicy)
      : undefined;
    this.bookingPolicy = _value.bookingPolicy
      ? new googleProtobuf000.StringValue(_value.bookingPolicy)
      : undefined;
    this.slotAttribute = _value.slotAttribute
      ? new googleProtobuf000.StringValue(_value.slotAttribute)
      : undefined;
    TimeSlot.refineValues(this);
  }
  get time(): string {
    return this._time;
  }
  set time(value: string) {
    this._time = value;
  }
  get slotType(): googleProtobuf000.StringValue | undefined {
    return this._slotType;
  }
  set slotType(value: googleProtobuf000.StringValue | undefined) {
    this._slotType = value;
  }
  get paymentRule(): PaymentRule {
    return this._paymentRule;
  }
  set paymentRule(value: PaymentRule) {
    this._paymentRule = value;
  }
  get totalReserveCost(): googleType001.Decimal | undefined {
    return this._totalReserveCost;
  }
  set totalReserveCost(value: googleType001.Decimal | undefined) {
    this._totalReserveCost = value;
  }
  get pregratuityTotal(): googleType001.Decimal | undefined {
    return this._pregratuityTotal;
  }
  set pregratuityTotal(value: googleType001.Decimal | undefined) {
    this._pregratuityTotal = value;
  }
  get mandatedGratuityAmount(): googleType001.Decimal | undefined {
    return this._mandatedGratuityAmount;
  }
  set mandatedGratuityAmount(value: googleType001.Decimal | undefined) {
    this._mandatedGratuityAmount = value;
  }
  get gratuity(): googleType001.Decimal | undefined {
    return this._gratuity;
  }
  set gratuity(value: googleType001.Decimal | undefined) {
    this._gratuity = value;
  }
  get subTotal(): googleType001.Decimal | undefined {
    return this._subTotal;
  }
  set subTotal(value: googleType001.Decimal | undefined) {
    this._subTotal = value;
  }
  get taxAmount(): googleType001.Decimal | undefined {
    return this._taxAmount;
  }
  set taxAmount(value: googleType001.Decimal | undefined) {
    this._taxAmount = value;
  }
  get serviceChargeAmount(): googleType001.Decimal | undefined {
    return this._serviceChargeAmount;
  }
  set serviceChargeAmount(value: googleType001.Decimal | undefined) {
    this._serviceChargeAmount = value;
  }
  get bookingToken(): googleProtobuf000.StringValue | undefined {
    return this._bookingToken;
  }
  set bookingToken(value: googleProtobuf000.StringValue | undefined) {
    this._bookingToken = value;
  }
  get cancellationPolicy(): googleProtobuf000.StringValue | undefined {
    return this._cancellationPolicy;
  }
  set cancellationPolicy(value: googleProtobuf000.StringValue | undefined) {
    this._cancellationPolicy = value;
  }
  get bookingPolicy(): googleProtobuf000.StringValue | undefined {
    return this._bookingPolicy;
  }
  set bookingPolicy(value: googleProtobuf000.StringValue | undefined) {
    this._bookingPolicy = value;
  }
  get slotAttribute(): googleProtobuf000.StringValue | undefined {
    return this._slotAttribute;
  }
  set slotAttribute(value: googleProtobuf000.StringValue | undefined) {
    this._slotAttribute = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TimeSlot.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TimeSlot.AsObject {
    return {
      time: this.time,
      slotType: this.slotType ? this.slotType.toObject() : undefined,
      paymentRule: this.paymentRule,
      totalReserveCost: this.totalReserveCost
        ? this.totalReserveCost.toObject()
        : undefined,
      pregratuityTotal: this.pregratuityTotal
        ? this.pregratuityTotal.toObject()
        : undefined,
      mandatedGratuityAmount: this.mandatedGratuityAmount
        ? this.mandatedGratuityAmount.toObject()
        : undefined,
      gratuity: this.gratuity ? this.gratuity.toObject() : undefined,
      subTotal: this.subTotal ? this.subTotal.toObject() : undefined,
      taxAmount: this.taxAmount ? this.taxAmount.toObject() : undefined,
      serviceChargeAmount: this.serviceChargeAmount
        ? this.serviceChargeAmount.toObject()
        : undefined,
      bookingToken: this.bookingToken
        ? this.bookingToken.toObject()
        : undefined,
      cancellationPolicy: this.cancellationPolicy
        ? this.cancellationPolicy.toObject()
        : undefined,
      bookingPolicy: this.bookingPolicy
        ? this.bookingPolicy.toObject()
        : undefined,
      slotAttribute: this.slotAttribute
        ? this.slotAttribute.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TimeSlot.AsProtobufJSON {
    return {
      time: this.time,
      slotType: this.slotType ? this.slotType.toProtobufJSON(options) : null,
      paymentRule:
        PaymentRule[
          this.paymentRule === null || this.paymentRule === undefined
            ? 0
            : this.paymentRule
        ],
      totalReserveCost: this.totalReserveCost
        ? this.totalReserveCost.toProtobufJSON(options)
        : null,
      pregratuityTotal: this.pregratuityTotal
        ? this.pregratuityTotal.toProtobufJSON(options)
        : null,
      mandatedGratuityAmount: this.mandatedGratuityAmount
        ? this.mandatedGratuityAmount.toProtobufJSON(options)
        : null,
      gratuity: this.gratuity ? this.gratuity.toProtobufJSON(options) : null,
      subTotal: this.subTotal ? this.subTotal.toProtobufJSON(options) : null,
      taxAmount: this.taxAmount ? this.taxAmount.toProtobufJSON(options) : null,
      serviceChargeAmount: this.serviceChargeAmount
        ? this.serviceChargeAmount.toProtobufJSON(options)
        : null,
      bookingToken: this.bookingToken
        ? this.bookingToken.toProtobufJSON(options)
        : null,
      cancellationPolicy: this.cancellationPolicy
        ? this.cancellationPolicy.toProtobufJSON(options)
        : null,
      bookingPolicy: this.bookingPolicy
        ? this.bookingPolicy.toProtobufJSON(options)
        : null,
      slotAttribute: this.slotAttribute
        ? this.slotAttribute.toProtobufJSON(options)
        : null
    };
  }
}
export module TimeSlot {
  /**
   * Standard JavaScript object representation for TimeSlot
   */
  export interface AsObject {
    time: string;
    slotType?: googleProtobuf000.StringValue.AsObject;
    paymentRule: PaymentRule;
    totalReserveCost?: googleType001.Decimal.AsObject;
    pregratuityTotal?: googleType001.Decimal.AsObject;
    mandatedGratuityAmount?: googleType001.Decimal.AsObject;
    gratuity?: googleType001.Decimal.AsObject;
    subTotal?: googleType001.Decimal.AsObject;
    taxAmount?: googleType001.Decimal.AsObject;
    serviceChargeAmount?: googleType001.Decimal.AsObject;
    bookingToken?: googleProtobuf000.StringValue.AsObject;
    cancellationPolicy?: googleProtobuf000.StringValue.AsObject;
    bookingPolicy?: googleProtobuf000.StringValue.AsObject;
    slotAttribute?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for TimeSlot
   */
  export interface AsProtobufJSON {
    time: string;
    slotType: googleProtobuf000.StringValue.AsProtobufJSON | null;
    paymentRule: string;
    totalReserveCost: googleType001.Decimal.AsProtobufJSON | null;
    pregratuityTotal: googleType001.Decimal.AsProtobufJSON | null;
    mandatedGratuityAmount: googleType001.Decimal.AsProtobufJSON | null;
    gratuity: googleType001.Decimal.AsProtobufJSON | null;
    subTotal: googleType001.Decimal.AsProtobufJSON | null;
    taxAmount: googleType001.Decimal.AsProtobufJSON | null;
    serviceChargeAmount: googleType001.Decimal.AsProtobufJSON | null;
    bookingToken: googleProtobuf000.StringValue.AsProtobufJSON | null;
    cancellationPolicy: googleProtobuf000.StringValue.AsProtobufJSON | null;
    bookingPolicy: googleProtobuf000.StringValue.AsProtobufJSON | null;
    slotAttribute: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.StartPaymentRequest
 */
export class StartPaymentRequest implements GrpcMessage {
  static id = 'booking_platform.v1.dining.StartPaymentRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new StartPaymentRequest();
    StartPaymentRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: StartPaymentRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.bookToken = _instance.bookToken || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: StartPaymentRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.bookToken = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    StartPaymentRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: StartPaymentRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.bookToken) {
      _writer.writeString(4, _instance.bookToken);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _bookToken: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of StartPaymentRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<StartPaymentRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.bookToken = _value.bookToken;
    StartPaymentRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get bookToken(): string {
    return this._bookToken;
  }
  set bookToken(value: string) {
    this._bookToken = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    StartPaymentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): StartPaymentRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookToken: this.bookToken
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): StartPaymentRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookToken: this.bookToken
    };
  }
}
export module StartPaymentRequest {
  /**
   * Standard JavaScript object representation for StartPaymentRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookToken: string;
  }

  /**
   * Protobuf JSON representation for StartPaymentRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookToken: string;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.StartPaymentResponse
 */
export class StartPaymentResponse implements GrpcMessage {
  static id = 'booking_platform.v1.dining.StartPaymentResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new StartPaymentResponse();
    StartPaymentResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: StartPaymentResponse) {
    _instance.publishableKey = _instance.publishableKey || '';
    _instance.accountId = _instance.accountId || '';
    _instance.clientSecret = _instance.clientSecret || '';
    _instance.bookToken = _instance.bookToken || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: StartPaymentResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.publishableKey = _reader.readString();
          break;
        case 2:
          _instance.accountId = _reader.readString();
          break;
        case 3:
          _instance.clientSecret = _reader.readString();
          break;
        case 4:
          _instance.bookToken = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    StartPaymentResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: StartPaymentResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.publishableKey) {
      _writer.writeString(1, _instance.publishableKey);
    }
    if (_instance.accountId) {
      _writer.writeString(2, _instance.accountId);
    }
    if (_instance.clientSecret) {
      _writer.writeString(3, _instance.clientSecret);
    }
    if (_instance.bookToken) {
      _writer.writeString(4, _instance.bookToken);
    }
  }

  private _publishableKey: string;
  private _accountId: string;
  private _clientSecret: string;
  private _bookToken: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of StartPaymentResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<StartPaymentResponse.AsObject>) {
    _value = _value || {};
    this.publishableKey = _value.publishableKey;
    this.accountId = _value.accountId;
    this.clientSecret = _value.clientSecret;
    this.bookToken = _value.bookToken;
    StartPaymentResponse.refineValues(this);
  }
  get publishableKey(): string {
    return this._publishableKey;
  }
  set publishableKey(value: string) {
    this._publishableKey = value;
  }
  get accountId(): string {
    return this._accountId;
  }
  set accountId(value: string) {
    this._accountId = value;
  }
  get clientSecret(): string {
    return this._clientSecret;
  }
  set clientSecret(value: string) {
    this._clientSecret = value;
  }
  get bookToken(): string {
    return this._bookToken;
  }
  set bookToken(value: string) {
    this._bookToken = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    StartPaymentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): StartPaymentResponse.AsObject {
    return {
      publishableKey: this.publishableKey,
      accountId: this.accountId,
      clientSecret: this.clientSecret,
      bookToken: this.bookToken
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): StartPaymentResponse.AsProtobufJSON {
    return {
      publishableKey: this.publishableKey,
      accountId: this.accountId,
      clientSecret: this.clientSecret,
      bookToken: this.bookToken
    };
  }
}
export module StartPaymentResponse {
  /**
   * Standard JavaScript object representation for StartPaymentResponse
   */
  export interface AsObject {
    publishableKey: string;
    accountId: string;
    clientSecret: string;
    bookToken: string;
  }

  /**
   * Protobuf JSON representation for StartPaymentResponse
   */
  export interface AsProtobufJSON {
    publishableKey: string;
    accountId: string;
    clientSecret: string;
    bookToken: string;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.VenueDetailsRequest
 */
export class VenueDetailsRequest implements GrpcMessage {
  static id = 'booking_platform.v1.dining.VenueDetailsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueDetailsRequest();
    VenueDetailsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueDetailsRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.venueIds = _instance.venueIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueDetailsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          (_instance.venueIds = _instance.venueIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    VenueDetailsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueDetailsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.venueIds && _instance.venueIds.length) {
      _writer.writePackedInt32(5, _instance.venueIds);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _venueIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueDetailsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueDetailsRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.venueIds = (_value.venueIds || []).slice();
    VenueDetailsRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get venueIds(): number[] {
    return this._venueIds;
  }
  set venueIds(value: number[]) {
    this._venueIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueDetailsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueDetailsRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      venueIds: (this.venueIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueDetailsRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      venueIds: (this.venueIds || []).slice()
    };
  }
}
export module VenueDetailsRequest {
  /**
   * Standard JavaScript object representation for VenueDetailsRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    venueIds: number[];
  }

  /**
   * Protobuf JSON representation for VenueDetailsRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    venueIds: number[];
  }
}

/**
 * Message implementation for booking_platform.v1.dining.VenueDetailsResponse
 */
export class VenueDetailsResponse implements GrpcMessage {
  static id = 'booking_platform.v1.dining.VenueDetailsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueDetailsResponse();
    VenueDetailsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueDetailsResponse) {
    _instance.venues = _instance.venues || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueDetailsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new VenueDetailsEntity();
          _reader.readMessage(
            messageInitializer1,
            VenueDetailsEntity.deserializeBinaryFromReader
          );
          (_instance.venues = _instance.venues || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    VenueDetailsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueDetailsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.venues && _instance.venues.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.venues as any,
        VenueDetailsEntity.serializeBinaryToWriter
      );
    }
  }

  private _venues?: VenueDetailsEntity[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueDetailsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueDetailsResponse.AsObject>) {
    _value = _value || {};
    this.venues = (_value.venues || []).map(m => new VenueDetailsEntity(m));
    VenueDetailsResponse.refineValues(this);
  }
  get venues(): VenueDetailsEntity[] | undefined {
    return this._venues;
  }
  set venues(value: VenueDetailsEntity[] | undefined) {
    this._venues = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueDetailsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueDetailsResponse.AsObject {
    return {
      venues: (this.venues || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueDetailsResponse.AsProtobufJSON {
    return {
      venues: (this.venues || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module VenueDetailsResponse {
  /**
   * Standard JavaScript object representation for VenueDetailsResponse
   */
  export interface AsObject {
    venues?: VenueDetailsEntity.AsObject[];
  }

  /**
   * Protobuf JSON representation for VenueDetailsResponse
   */
  export interface AsProtobufJSON {
    venues: VenueDetailsEntity.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.VenueDetailsEntity
 */
export class VenueDetailsEntity implements GrpcMessage {
  static id = 'booking_platform.v1.dining.VenueDetailsEntity';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueDetailsEntity();
    VenueDetailsEntity.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueDetailsEntity) {
    _instance.venueId = _instance.venueId || 0;
    _instance.name = _instance.name || '';
    _instance.locationName = _instance.locationName || '';
    _instance.address = _instance.address || '';
    _instance.geolocation = _instance.geolocation || undefined;
    _instance.images = _instance.images || [];
    _instance.attributes = _instance.attributes || [];
    _instance.description = _instance.description || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueDetailsEntity,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.venueId = _reader.readInt32();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        case 3:
          _instance.locationName = _reader.readString();
          break;
        case 4:
          _instance.address = _reader.readString();
          break;
        case 5:
          _instance.geolocation = new booking_platformV1Shared002.Geolocation();
          _reader.readMessage(
            _instance.geolocation,
            booking_platformV1Shared002.Geolocation.deserializeBinaryFromReader
          );
          break;
        case 6:
          (_instance.images = _instance.images || []).push(
            _reader.readString()
          );
          break;
        case 7:
          const messageInitializer7 = new Attribute();
          _reader.readMessage(
            messageInitializer7,
            Attribute.deserializeBinaryFromReader
          );
          (_instance.attributes = _instance.attributes || []).push(
            messageInitializer7
          );
          break;
        case 8:
          _instance.description = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.description,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    VenueDetailsEntity.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueDetailsEntity,
    _writer: BinaryWriter
  ) {
    if (_instance.venueId) {
      _writer.writeInt32(1, _instance.venueId);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
    if (_instance.locationName) {
      _writer.writeString(3, _instance.locationName);
    }
    if (_instance.address) {
      _writer.writeString(4, _instance.address);
    }
    if (_instance.geolocation) {
      _writer.writeMessage(
        5,
        _instance.geolocation as any,
        booking_platformV1Shared002.Geolocation.serializeBinaryToWriter
      );
    }
    if (_instance.images && _instance.images.length) {
      _writer.writeRepeatedString(6, _instance.images);
    }
    if (_instance.attributes && _instance.attributes.length) {
      _writer.writeRepeatedMessage(
        7,
        _instance.attributes as any,
        Attribute.serializeBinaryToWriter
      );
    }
    if (_instance.description) {
      _writer.writeMessage(
        8,
        _instance.description as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _venueId: number;
  private _name: string;
  private _locationName: string;
  private _address: string;
  private _geolocation?: booking_platformV1Shared002.Geolocation;
  private _images: string[];
  private _attributes?: Attribute[];
  private _description?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueDetailsEntity to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueDetailsEntity.AsObject>) {
    _value = _value || {};
    this.venueId = _value.venueId;
    this.name = _value.name;
    this.locationName = _value.locationName;
    this.address = _value.address;
    this.geolocation = _value.geolocation
      ? new booking_platformV1Shared002.Geolocation(_value.geolocation)
      : undefined;
    this.images = (_value.images || []).slice();
    this.attributes = (_value.attributes || []).map(m => new Attribute(m));
    this.description = _value.description
      ? new googleProtobuf000.StringValue(_value.description)
      : undefined;
    VenueDetailsEntity.refineValues(this);
  }
  get venueId(): number {
    return this._venueId;
  }
  set venueId(value: number) {
    this._venueId = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }
  get locationName(): string {
    return this._locationName;
  }
  set locationName(value: string) {
    this._locationName = value;
  }
  get address(): string {
    return this._address;
  }
  set address(value: string) {
    this._address = value;
  }
  get geolocation(): booking_platformV1Shared002.Geolocation | undefined {
    return this._geolocation;
  }
  set geolocation(value: booking_platformV1Shared002.Geolocation | undefined) {
    this._geolocation = value;
  }
  get images(): string[] {
    return this._images;
  }
  set images(value: string[]) {
    this._images = value;
  }
  get attributes(): Attribute[] | undefined {
    return this._attributes;
  }
  set attributes(value: Attribute[] | undefined) {
    this._attributes = value;
  }
  get description(): googleProtobuf000.StringValue | undefined {
    return this._description;
  }
  set description(value: googleProtobuf000.StringValue | undefined) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueDetailsEntity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueDetailsEntity.AsObject {
    return {
      venueId: this.venueId,
      name: this.name,
      locationName: this.locationName,
      address: this.address,
      geolocation: this.geolocation ? this.geolocation.toObject() : undefined,
      images: (this.images || []).slice(),
      attributes: (this.attributes || []).map(m => m.toObject()),
      description: this.description ? this.description.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueDetailsEntity.AsProtobufJSON {
    return {
      venueId: this.venueId,
      name: this.name,
      locationName: this.locationName,
      address: this.address,
      geolocation: this.geolocation
        ? this.geolocation.toProtobufJSON(options)
        : null,
      images: (this.images || []).slice(),
      attributes: (this.attributes || []).map(m => m.toProtobufJSON(options)),
      description: this.description
        ? this.description.toProtobufJSON(options)
        : null
    };
  }
}
export module VenueDetailsEntity {
  /**
   * Standard JavaScript object representation for VenueDetailsEntity
   */
  export interface AsObject {
    venueId: number;
    name: string;
    locationName: string;
    address: string;
    geolocation?: booking_platformV1Shared002.Geolocation.AsObject;
    images: string[];
    attributes?: Attribute.AsObject[];
    description?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for VenueDetailsEntity
   */
  export interface AsProtobufJSON {
    venueId: number;
    name: string;
    locationName: string;
    address: string;
    geolocation: booking_platformV1Shared002.Geolocation.AsProtobufJSON | null;
    images: string[];
    attributes: Attribute.AsProtobufJSON[] | null;
    description: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.Attribute
 */
export class Attribute implements GrpcMessage {
  static id = 'booking_platform.v1.dining.Attribute';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Attribute();
    Attribute.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Attribute) {
    _instance.id = _instance.id || 0;
    _instance.type = _instance.type || '';
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Attribute,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.type = _reader.readString();
          break;
        case 3:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    Attribute.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Attribute, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.type) {
      _writer.writeString(2, _instance.type);
    }
    if (_instance.name) {
      _writer.writeString(3, _instance.name);
    }
  }

  private _id: number;
  private _type: string;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Attribute to deeply clone from
   */
  constructor(_value?: RecursivePartial<Attribute.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.type = _value.type;
    this.name = _value.name;
    Attribute.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get type(): string {
    return this._type;
  }
  set type(value: string) {
    this._type = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Attribute.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Attribute.AsObject {
    return {
      id: this.id,
      type: this.type,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Attribute.AsProtobufJSON {
    return {
      id: this.id,
      type: this.type,
      name: this.name
    };
  }
}
export module Attribute {
  /**
   * Standard JavaScript object representation for Attribute
   */
  export interface AsObject {
    id: number;
    type: string;
    name: string;
  }

  /**
   * Protobuf JSON representation for Attribute
   */
  export interface AsProtobufJSON {
    id: number;
    type: string;
    name: string;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.SearchVenuesRequest
 */
export class SearchVenuesRequest implements GrpcMessage {
  static id = 'booking_platform.v1.dining.SearchVenuesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchVenuesRequest();
    SearchVenuesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchVenuesRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.geolocation = _instance.geolocation || undefined;
    _instance.attributeIds = _instance.attributeIds || [];
    _instance.languageCode = _instance.languageCode || '';
    _instance.numberOfVenues = _instance.numberOfVenues || 0;
    _instance.startingSearchRadius =
      _instance.startingSearchRadius || undefined;
    _instance.maxSearchRadius = _instance.maxSearchRadius || undefined;
    _instance.searchRadiusIncrement =
      _instance.searchRadiusIncrement || undefined;
    _instance.hasBenefits = _instance.hasBenefits || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchVenuesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.geolocation = new booking_platformV1Shared002.Geolocation();
          _reader.readMessage(
            _instance.geolocation,
            booking_platformV1Shared002.Geolocation.deserializeBinaryFromReader
          );
          break;
        case 5:
          (_instance.attributeIds = _instance.attributeIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        case 6:
          _instance.languageCode = _reader.readString();
          break;
        case 7:
          _instance.numberOfVenues = _reader.readInt32();
          break;
        case 8:
          _instance.startingSearchRadius = new googleProtobuf000.Int32Value();
          _reader.readMessage(
            _instance.startingSearchRadius,
            googleProtobuf000.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.maxSearchRadius = new googleProtobuf000.Int32Value();
          _reader.readMessage(
            _instance.maxSearchRadius,
            googleProtobuf000.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 10:
          _instance.searchRadiusIncrement = new googleProtobuf000.Int32Value();
          _reader.readMessage(
            _instance.searchRadiusIncrement,
            googleProtobuf000.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.hasBenefits = new googleProtobuf000.BoolValue();
          _reader.readMessage(
            _instance.hasBenefits,
            googleProtobuf000.BoolValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SearchVenuesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchVenuesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.geolocation) {
      _writer.writeMessage(
        4,
        _instance.geolocation as any,
        booking_platformV1Shared002.Geolocation.serializeBinaryToWriter
      );
    }
    if (_instance.attributeIds && _instance.attributeIds.length) {
      _writer.writePackedInt32(5, _instance.attributeIds);
    }
    if (_instance.languageCode) {
      _writer.writeString(6, _instance.languageCode);
    }
    if (_instance.numberOfVenues) {
      _writer.writeInt32(7, _instance.numberOfVenues);
    }
    if (_instance.startingSearchRadius) {
      _writer.writeMessage(
        8,
        _instance.startingSearchRadius as any,
        googleProtobuf000.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.maxSearchRadius) {
      _writer.writeMessage(
        9,
        _instance.maxSearchRadius as any,
        googleProtobuf000.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.searchRadiusIncrement) {
      _writer.writeMessage(
        10,
        _instance.searchRadiusIncrement as any,
        googleProtobuf000.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.hasBenefits) {
      _writer.writeMessage(
        11,
        _instance.hasBenefits as any,
        googleProtobuf000.BoolValue.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _geolocation?: booking_platformV1Shared002.Geolocation;
  private _attributeIds: number[];
  private _languageCode: string;
  private _numberOfVenues: number;
  private _startingSearchRadius?: googleProtobuf000.Int32Value;
  private _maxSearchRadius?: googleProtobuf000.Int32Value;
  private _searchRadiusIncrement?: googleProtobuf000.Int32Value;
  private _hasBenefits?: googleProtobuf000.BoolValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchVenuesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchVenuesRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.geolocation = _value.geolocation
      ? new booking_platformV1Shared002.Geolocation(_value.geolocation)
      : undefined;
    this.attributeIds = (_value.attributeIds || []).slice();
    this.languageCode = _value.languageCode;
    this.numberOfVenues = _value.numberOfVenues;
    this.startingSearchRadius = _value.startingSearchRadius
      ? new googleProtobuf000.Int32Value(_value.startingSearchRadius)
      : undefined;
    this.maxSearchRadius = _value.maxSearchRadius
      ? new googleProtobuf000.Int32Value(_value.maxSearchRadius)
      : undefined;
    this.searchRadiusIncrement = _value.searchRadiusIncrement
      ? new googleProtobuf000.Int32Value(_value.searchRadiusIncrement)
      : undefined;
    this.hasBenefits = _value.hasBenefits
      ? new googleProtobuf000.BoolValue(_value.hasBenefits)
      : undefined;
    SearchVenuesRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get geolocation(): booking_platformV1Shared002.Geolocation | undefined {
    return this._geolocation;
  }
  set geolocation(value: booking_platformV1Shared002.Geolocation | undefined) {
    this._geolocation = value;
  }
  get attributeIds(): number[] {
    return this._attributeIds;
  }
  set attributeIds(value: number[]) {
    this._attributeIds = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get numberOfVenues(): number {
    return this._numberOfVenues;
  }
  set numberOfVenues(value: number) {
    this._numberOfVenues = value;
  }
  get startingSearchRadius(): googleProtobuf000.Int32Value | undefined {
    return this._startingSearchRadius;
  }
  set startingSearchRadius(value: googleProtobuf000.Int32Value | undefined) {
    this._startingSearchRadius = value;
  }
  get maxSearchRadius(): googleProtobuf000.Int32Value | undefined {
    return this._maxSearchRadius;
  }
  set maxSearchRadius(value: googleProtobuf000.Int32Value | undefined) {
    this._maxSearchRadius = value;
  }
  get searchRadiusIncrement(): googleProtobuf000.Int32Value | undefined {
    return this._searchRadiusIncrement;
  }
  set searchRadiusIncrement(value: googleProtobuf000.Int32Value | undefined) {
    this._searchRadiusIncrement = value;
  }
  get hasBenefits(): googleProtobuf000.BoolValue | undefined {
    return this._hasBenefits;
  }
  set hasBenefits(value: googleProtobuf000.BoolValue | undefined) {
    this._hasBenefits = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchVenuesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchVenuesRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      geolocation: this.geolocation ? this.geolocation.toObject() : undefined,
      attributeIds: (this.attributeIds || []).slice(),
      languageCode: this.languageCode,
      numberOfVenues: this.numberOfVenues,
      startingSearchRadius: this.startingSearchRadius
        ? this.startingSearchRadius.toObject()
        : undefined,
      maxSearchRadius: this.maxSearchRadius
        ? this.maxSearchRadius.toObject()
        : undefined,
      searchRadiusIncrement: this.searchRadiusIncrement
        ? this.searchRadiusIncrement.toObject()
        : undefined,
      hasBenefits: this.hasBenefits ? this.hasBenefits.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchVenuesRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      geolocation: this.geolocation
        ? this.geolocation.toProtobufJSON(options)
        : null,
      attributeIds: (this.attributeIds || []).slice(),
      languageCode: this.languageCode,
      numberOfVenues: this.numberOfVenues,
      startingSearchRadius: this.startingSearchRadius
        ? this.startingSearchRadius.toProtobufJSON(options)
        : null,
      maxSearchRadius: this.maxSearchRadius
        ? this.maxSearchRadius.toProtobufJSON(options)
        : null,
      searchRadiusIncrement: this.searchRadiusIncrement
        ? this.searchRadiusIncrement.toProtobufJSON(options)
        : null,
      hasBenefits: this.hasBenefits
        ? this.hasBenefits.toProtobufJSON(options)
        : null
    };
  }
}
export module SearchVenuesRequest {
  /**
   * Standard JavaScript object representation for SearchVenuesRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    geolocation?: booking_platformV1Shared002.Geolocation.AsObject;
    attributeIds: number[];
    languageCode: string;
    numberOfVenues: number;
    startingSearchRadius?: googleProtobuf000.Int32Value.AsObject;
    maxSearchRadius?: googleProtobuf000.Int32Value.AsObject;
    searchRadiusIncrement?: googleProtobuf000.Int32Value.AsObject;
    hasBenefits?: googleProtobuf000.BoolValue.AsObject;
  }

  /**
   * Protobuf JSON representation for SearchVenuesRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    geolocation: booking_platformV1Shared002.Geolocation.AsProtobufJSON | null;
    attributeIds: number[];
    languageCode: string;
    numberOfVenues: number;
    startingSearchRadius: googleProtobuf000.Int32Value.AsProtobufJSON | null;
    maxSearchRadius: googleProtobuf000.Int32Value.AsProtobufJSON | null;
    searchRadiusIncrement: googleProtobuf000.Int32Value.AsProtobufJSON | null;
    hasBenefits: googleProtobuf000.BoolValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.VenueBenefitsRequest
 */
export class VenueBenefitsRequest implements GrpcMessage {
  static id = 'booking_platform.v1.dining.VenueBenefitsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueBenefitsRequest();
    VenueBenefitsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueBenefitsRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.venueIds = _instance.venueIds || [];
    _instance.languageCode = _instance.languageCode || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueBenefitsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          (_instance.venueIds = _instance.venueIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        case 5:
          _instance.languageCode = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    VenueBenefitsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueBenefitsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.venueIds && _instance.venueIds.length) {
      _writer.writePackedInt32(4, _instance.venueIds);
    }
    if (_instance.languageCode) {
      _writer.writeString(5, _instance.languageCode);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _venueIds: number[];
  private _languageCode: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueBenefitsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueBenefitsRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.venueIds = (_value.venueIds || []).slice();
    this.languageCode = _value.languageCode;
    VenueBenefitsRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get venueIds(): number[] {
    return this._venueIds;
  }
  set venueIds(value: number[]) {
    this._venueIds = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueBenefitsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueBenefitsRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      venueIds: (this.venueIds || []).slice(),
      languageCode: this.languageCode
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueBenefitsRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      venueIds: (this.venueIds || []).slice(),
      languageCode: this.languageCode
    };
  }
}
export module VenueBenefitsRequest {
  /**
   * Standard JavaScript object representation for VenueBenefitsRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    venueIds: number[];
    languageCode: string;
  }

  /**
   * Protobuf JSON representation for VenueBenefitsRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    venueIds: number[];
    languageCode: string;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.VenueBenefitsResponse
 */
export class VenueBenefitsResponse implements GrpcMessage {
  static id = 'booking_platform.v1.dining.VenueBenefitsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueBenefitsResponse();
    VenueBenefitsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueBenefitsResponse) {
    _instance.venues = _instance.venues || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueBenefitsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new VenueBenefitItem();
          _reader.readMessage(
            messageInitializer1,
            VenueBenefitItem.deserializeBinaryFromReader
          );
          (_instance.venues = _instance.venues || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    VenueBenefitsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueBenefitsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.venues && _instance.venues.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.venues as any,
        VenueBenefitItem.serializeBinaryToWriter
      );
    }
  }

  private _venues?: VenueBenefitItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueBenefitsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueBenefitsResponse.AsObject>) {
    _value = _value || {};
    this.venues = (_value.venues || []).map(m => new VenueBenefitItem(m));
    VenueBenefitsResponse.refineValues(this);
  }
  get venues(): VenueBenefitItem[] | undefined {
    return this._venues;
  }
  set venues(value: VenueBenefitItem[] | undefined) {
    this._venues = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueBenefitsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueBenefitsResponse.AsObject {
    return {
      venues: (this.venues || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueBenefitsResponse.AsProtobufJSON {
    return {
      venues: (this.venues || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module VenueBenefitsResponse {
  /**
   * Standard JavaScript object representation for VenueBenefitsResponse
   */
  export interface AsObject {
    venues?: VenueBenefitItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for VenueBenefitsResponse
   */
  export interface AsProtobufJSON {
    venues: VenueBenefitItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.VenueBenefitItem
 */
export class VenueBenefitItem implements GrpcMessage {
  static id = 'booking_platform.v1.dining.VenueBenefitItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueBenefitItem();
    VenueBenefitItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueBenefitItem) {
    _instance.venueId = _instance.venueId || 0;
    _instance.benefits = _instance.benefits || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueBenefitItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.venueId = _reader.readInt32();
          break;
        case 2:
          const messageInitializer2 = new booking_platformV1Shared004.BenefitItem();
          _reader.readMessage(
            messageInitializer2,
            booking_platformV1Shared004.BenefitItem.deserializeBinaryFromReader
          );
          (_instance.benefits = _instance.benefits || []).push(
            messageInitializer2
          );
          break;
        default:
          _reader.skipField();
      }
    }

    VenueBenefitItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueBenefitItem,
    _writer: BinaryWriter
  ) {
    if (_instance.venueId) {
      _writer.writeInt32(1, _instance.venueId);
    }
    if (_instance.benefits && _instance.benefits.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.benefits as any,
        booking_platformV1Shared004.BenefitItem.serializeBinaryToWriter
      );
    }
  }

  private _venueId: number;
  private _benefits?: booking_platformV1Shared004.BenefitItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueBenefitItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueBenefitItem.AsObject>) {
    _value = _value || {};
    this.venueId = _value.venueId;
    this.benefits = (_value.benefits || []).map(
      m => new booking_platformV1Shared004.BenefitItem(m)
    );
    VenueBenefitItem.refineValues(this);
  }
  get venueId(): number {
    return this._venueId;
  }
  set venueId(value: number) {
    this._venueId = value;
  }
  get benefits(): booking_platformV1Shared004.BenefitItem[] | undefined {
    return this._benefits;
  }
  set benefits(value: booking_platformV1Shared004.BenefitItem[] | undefined) {
    this._benefits = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueBenefitItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueBenefitItem.AsObject {
    return {
      venueId: this.venueId,
      benefits: (this.benefits || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueBenefitItem.AsProtobufJSON {
    return {
      venueId: this.venueId,
      benefits: (this.benefits || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module VenueBenefitItem {
  /**
   * Standard JavaScript object representation for VenueBenefitItem
   */
  export interface AsObject {
    venueId: number;
    benefits?: booking_platformV1Shared004.BenefitItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for VenueBenefitItem
   */
  export interface AsProtobufJSON {
    venueId: number;
    benefits: booking_platformV1Shared004.BenefitItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.ReserveSlotRequest
 */
export class ReserveSlotRequest implements GrpcMessage {
  static id = 'booking_platform.v1.dining.ReserveSlotRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ReserveSlotRequest();
    ReserveSlotRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ReserveSlotRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.bookToken = _instance.bookToken || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ReserveSlotRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.bookToken = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ReserveSlotRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ReserveSlotRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.bookToken) {
      _writer.writeString(4, _instance.bookToken);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _bookToken: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ReserveSlotRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ReserveSlotRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.bookToken = _value.bookToken;
    ReserveSlotRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get bookToken(): string {
    return this._bookToken;
  }
  set bookToken(value: string) {
    this._bookToken = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ReserveSlotRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ReserveSlotRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookToken: this.bookToken
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ReserveSlotRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookToken: this.bookToken
    };
  }
}
export module ReserveSlotRequest {
  /**
   * Standard JavaScript object representation for ReserveSlotRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookToken: string;
  }

  /**
   * Protobuf JSON representation for ReserveSlotRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookToken: string;
  }
}

/**
 * Message implementation for booking_platform.v1.dining.ReserveSlotResponse
 */
export class ReserveSlotResponse implements GrpcMessage {
  static id = 'booking_platform.v1.dining.ReserveSlotResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ReserveSlotResponse();
    ReserveSlotResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ReserveSlotResponse) {
    _instance.reserveSlotToken = _instance.reserveSlotToken || '';
    _instance.expiresAtUtc = _instance.expiresAtUtc || undefined;
    _instance.supplierName = _instance.supplierName || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ReserveSlotResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.reserveSlotToken = _reader.readString();
          break;
        case 2:
          _instance.expiresAtUtc = new googleProtobuf005.Timestamp();
          _reader.readMessage(
            _instance.expiresAtUtc,
            googleProtobuf005.Timestamp.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.supplierName = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ReserveSlotResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ReserveSlotResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.reserveSlotToken) {
      _writer.writeString(1, _instance.reserveSlotToken);
    }
    if (_instance.expiresAtUtc) {
      _writer.writeMessage(
        2,
        _instance.expiresAtUtc as any,
        googleProtobuf005.Timestamp.serializeBinaryToWriter
      );
    }
    if (_instance.supplierName) {
      _writer.writeString(3, _instance.supplierName);
    }
  }

  private _reserveSlotToken: string;
  private _expiresAtUtc?: googleProtobuf005.Timestamp;
  private _supplierName: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ReserveSlotResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<ReserveSlotResponse.AsObject>) {
    _value = _value || {};
    this.reserveSlotToken = _value.reserveSlotToken;
    this.expiresAtUtc = _value.expiresAtUtc
      ? new googleProtobuf005.Timestamp(_value.expiresAtUtc)
      : undefined;
    this.supplierName = _value.supplierName;
    ReserveSlotResponse.refineValues(this);
  }
  get reserveSlotToken(): string {
    return this._reserveSlotToken;
  }
  set reserveSlotToken(value: string) {
    this._reserveSlotToken = value;
  }
  get expiresAtUtc(): googleProtobuf005.Timestamp | undefined {
    return this._expiresAtUtc;
  }
  set expiresAtUtc(value: googleProtobuf005.Timestamp | undefined) {
    this._expiresAtUtc = value;
  }
  get supplierName(): string {
    return this._supplierName;
  }
  set supplierName(value: string) {
    this._supplierName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ReserveSlotResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ReserveSlotResponse.AsObject {
    return {
      reserveSlotToken: this.reserveSlotToken,
      expiresAtUtc: this.expiresAtUtc
        ? this.expiresAtUtc.toObject()
        : undefined,
      supplierName: this.supplierName
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ReserveSlotResponse.AsProtobufJSON {
    return {
      reserveSlotToken: this.reserveSlotToken,
      expiresAtUtc: this.expiresAtUtc
        ? this.expiresAtUtc.toProtobufJSON(options)
        : null,
      supplierName: this.supplierName
    };
  }
}
export module ReserveSlotResponse {
  /**
   * Standard JavaScript object representation for ReserveSlotResponse
   */
  export interface AsObject {
    reserveSlotToken: string;
    expiresAtUtc?: googleProtobuf005.Timestamp.AsObject;
    supplierName: string;
  }

  /**
   * Protobuf JSON representation for ReserveSlotResponse
   */
  export interface AsProtobufJSON {
    reserveSlotToken: string;
    expiresAtUtc: googleProtobuf005.Timestamp.AsProtobufJSON | null;
    supplierName: string;
  }
}
